import React, { createContext, useState, useContext, ReactNode } from 'react';

interface SubscriptionContextType {
  isSubscribed: boolean;
  activateSubscription: () => void;
}

const SubscriptionContext = createContext<SubscriptionContextType | undefined>(undefined);

export const SubscriptionProvider: React.FC<{children: ReactNode}> = ({ children }) => {
  const [isSubscribed, setIsSubscribed] = useState(false);

  const activateSubscription = () => {
    setIsSubscribed(true);
  };

  return (
    <SubscriptionContext.Provider value={{ isSubscribed, activateSubscription }}>
      {children}
    </SubscriptionContext.Provider>
  );
};

export const useSubscription = () => {
  const context = useContext(SubscriptionContext);
  if (context === undefined) {
    throw new Error('useSubscription must be used within a SubscriptionProvider');
  }
  return context;
};
